import React, {useEffect} from 'react';
import {TextArea} from '@/components/atoms';
import {withJsonFormsControlProps} from '@jsonforms/react';
import PropTypes from 'prop-types';

const TextAreaComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    error,
    schema,
    uischema,
    required,
    enabled,
    visible
  } = props;

  useEffect(() => {
    if (!enabled && data) {
      handleChange(path, '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  const updateValue = (newVal, isValid) => {
    const value = schema.type === 'string' && newVal ? newVal.trim() : newVal;
    handleChange(path, value);
    handleChange(path + 'Valid', isValid);
  };

  return visible ? (
    <TextArea
      value={data || ''}
      label={uischema.showLabel === false ? '' : label}
      updateValue={updateValue}
      error={error}
      schema={schema}
      uiSchema={uischema}
      required={required}
      disabled={!enabled}
    />
  ) : null;
};

TextAreaComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  path: PropTypes.string.isRequired,
  error: PropTypes.string,
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.object,
  required: PropTypes.bool,
  enabled: PropTypes.bool,
  visible: PropTypes.bool
};

const TextAreaControl = withJsonFormsControlProps(TextAreaComponent);
export default React.memo(TextAreaControl);
